import { XCircle, ArrowLeft, HelpCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function PaymentCancelled() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-emerald-50 flex items-center justify-center px-4">
      <div className="max-w-2xl w-full bg-white rounded-2xl p-8 md:p-12 shadow-xl border-2 border-gray-200">
        <div className="text-center mb-8">
          <div className="w-20 h-20 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <XCircle className="w-12 h-12 text-yellow-600" />
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Payment Cancelled
          </h1>
          <p className="text-xl text-gray-600">
            Your payment was not completed. No charges were made to your account.
          </p>
        </div>

        <div className="bg-blue-50 border border-blue-200 rounded-xl p-6 mb-8">
          <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center gap-2">
            <HelpCircle className="w-5 h-5 text-blue-600" />
            Why might this have happened?
          </h3>
          <ul className="space-y-2 text-gray-700">
            <li className="flex items-start gap-2">
              <span className="text-blue-600 font-bold">•</span>
              <span>You clicked the back button or closed the payment window</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-blue-600 font-bold">•</span>
              <span>Your payment information couldn't be verified</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-blue-600 font-bold">•</span>
              <span>You decided to review the details before purchasing</span>
            </li>
          </ul>
        </div>

        <div className="space-y-4">
          <button
            onClick={() => navigate('/site-owner-payment')}
            className="w-full bg-gradient-to-r from-blue-600 to-emerald-600 text-white px-8 py-4 rounded-lg font-bold text-lg hover:shadow-xl transition-all duration-300 hover:scale-105 flex items-center justify-center gap-2"
          >
            <ArrowLeft className="w-5 h-5" />
            Return to Pricing
          </button>

          <button
            onClick={() => navigate('/wordpress-plugin')}
            className="w-full bg-gray-100 text-gray-900 px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-200 transition-all duration-300"
          >
            Back to Plugin Page
          </button>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-200">
          <p className="text-center text-gray-600 mb-4">
            Have questions or need help?
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="mailto:support@resumedoctor.ai"
              className="text-blue-600 hover:text-blue-700 font-semibold"
            >
              Contact Support
            </a>
            <span className="hidden sm:inline text-gray-400">•</span>
            <button
              onClick={() => navigate('/wordpress-plugin#documentation')}
              className="text-blue-600 hover:text-blue-700 font-semibold"
            >
              View Documentation
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
